import { gql } from 'graphql-tag'
import {
  fragmentModuleTerminalConnectivitySpecs,
  fragmentModuleTerminalHardwareSpecs,
  fragmentModuleTerminalIntegrationSpecs,
  fragmentModuleTerminalPaymentExperienceSpecs
} from '../../modules/fragments'

export default gql`
  ${fragmentModuleTerminalHardwareSpecs}
  ${fragmentModuleTerminalConnectivitySpecs}
  ${fragmentModuleTerminalPaymentExperienceSpecs}
  ${fragmentModuleTerminalIntegrationSpecs}
  fragment BlockTerminalSpecsFragment on BlockTerminalSpecs {
    hardwareTitle
    hardwareCollection(limit: 3) {
      items {
        ...ModuleTerminalHardwareSpecsFragment
      }
    }
    connectivityTitle
    connectivityCollection(limit: 1) {
      items {
        ...ModuleTerminalConnectivitySpecsFragment
      }
    }
    paymentExperienceTitle
    paymentExperienceCollection(limit: 1) {
      items {
        ...ModuleTerminalPaymentExperienceSpecsFragment
      }
    }
    integrationTitle
    integrationCollection(limit: 1) {
      items {
        ...ModuleTerminalIntegrationSpecsFragment
      }
    }
  }
`
